import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Warning = forwardRef<SVGSVGElement, SvgIconProps>(
  function Warning(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m13.398217,3.380552l9.895012,16.517581c0.28382,0.473776 0.12983,1.08793 -0.343947,1.371751c-0.155278,0.093021 -0.332893,0.142151 -0.513902,0.142151l-20.870913,0c-0.552284,0 -1,-0.447715 -1,-1c0,-0.181009 0.049131,-0.358624 0.142152,-0.513902l9.895011,-16.517581c0.462627,-0.772257 1.463698,-1.02326 2.235954,-0.560633c0.230172,0.137887 0.422746,0.330461 0.560633,0.560633zm0.661419,5.198858c0,-0.86561 -0.897091,-1.56754 -2.00349,-1.56754c-1.1064,0 -2.00349,0.701888 -2.00349,1.56754l1.38671,5.425898c0.134933,0.527039 1.097912,0.527039 1.232845,0l1.387425,-5.425898zm-0.879046,9.155956c0,-0.614601 -0.52871,-1.112751 -1.180666,-1.112751c-0.651957,0 -1.180667,0.498095 -1.180667,1.112751c0,0.614272 0.52871,1.112422 1.180667,1.112422c0.651956,0 1.180666,-0.498194 1.180666,-1.112422z" />
      </SvgIcon>
    )
  },
)

export default Warning
